import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

function normalizeVisible(result: unknown): boolean {
  if (typeof result === 'boolean') return result;
  if (result != null && typeof result === 'object' && 'visible' in result) {
    return (result as { visible?: boolean }).visible !== false;
  }
  return false;
}

export function isGroupsEnabled(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Groups Enabled',
    description: 'True when brugergrupperinger are enabled for the user\'s organization',
    requiresContext: false,
    execute: () => {
      const obs = service.executeDataSource('duna_groups_enabled');
      if (!obs) {
        return of(false);
      }
      return obs.pipe(
        map(normalizeVisible),
        catchError(() => of(false))
      );
    }
  };
}
